window.addEventListener('load', () => {

	const loaderOverlay = document.getElementById('loaderOverlay')

	setTimeout(() => {
		loaderOverlay.classList.add('hide');
	}, 1000);
});
